import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { EditType } from './EditType';

interface props {
  edit: (e: EditType) => void;
  label?: string;
  variant?: 'body2';
}

export function ItemCustoms(props: props) {
  return (
    <P2GLink variant={props.variant} onClick={() => props.edit && props.edit('CUSTOMS')}>
      {props.label || 'Customs'}
    </P2GLink>
  );
}

export function ItemCustomsMobile(props: props) {
  return (
    <P2GGrid container gap={1} alignItems="center" wrap="nowrap">
      <P2GGrid item flexGrow={1}>
        <P2GText variant={props.variant}>{props.label || 'Customs'}</P2GText>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        <P2GLink variant={props.variant} onClick={() => props.edit && props.edit('CUSTOMS')}>
          Edit
        </P2GLink>
      </P2GGrid>
    </P2GGrid>
  );
}
